import { Component } from 'react';
import { Route } from 'react-router-dom';
import SplitIOTreatment from './splitioTreatment';
import WrapperComponent from './wrapperComponent';

class SplitIORoute extends Component {
  render() {
    const { featureName, trafficType, ...rest } = this.props;
    return (
      <SplitIOTreatment featureName={featureName} treatmentValue="on" trafficType={trafficType}>
        {(treatment) => {
          return (
            <Route
              {...rest}
              render={(props) => {
                return <WrapperComponent {...props} {...rest} treatment={treatment} />;
              }}
            />
          );
        }}
      </SplitIOTreatment>
    );
  }
}

export default SplitIORoute;
